import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";
import { fadeUp, staggerParent } from "../lib/motion";

// Premium split-screen authentication shell.
// Left: cinematic brand panel. Right: the form. Mobile collapses to form-first.
export default function AuthShell({ title, subtitle, children, footer, testId }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid={testId}>
      <div className="relative hidden lg:block overflow-hidden">
        <img src="https://images.unsplash.com/photo-1533106418989-88406c7cc8ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
             alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(200deg, rgba(8,11,13,0.45) 0%, rgba(8,11,13,0.94) 85%)" }} />
        <div className="relative h-full flex flex-col justify-between p-12">
          <Logo />
          <div>
            <p className="section-label">MyRedPark</p>
            <p className="font-display font-bold text-4xl leading-[1.05] tracking-tight mt-5">Your Spot.<br />Your Way.</p>
            <p className="mt-4 text-sm text-zinc-400 max-w-xs leading-relaxed">
              Real parking spaces from local hosts. Verified arrival. Payment only when you park.
            </p>
          </div>
          <p className="text-xs text-zinc-600">© 2026 Zopytech Ltd. All rights reserved.</p>
        </div>
      </div>
      <div className="flex flex-col px-5 sm:px-10 py-8">
        <div className="flex items-center justify-between">
          <span className="lg:hidden"><Logo compact /></span>
          <Link to="/" className="ml-auto inline-flex items-center gap-1.5 text-xs text-zinc-500 hover:text-white transition-colors" data-testid="auth-back-home">
            <ArrowLeft className="w-3.5 h-3.5" /> Home
          </Link>
        </div>
        <div className="flex-1 flex items-center justify-center py-10">
          <motion.div variants={staggerParent(0.07)} initial="hidden" animate="show" className="w-full max-w-[24rem]">
            <motion.h1 variants={fadeUp} className="font-display font-bold text-3xl tracking-tight" data-testid={`${testId}-title`}>{title}</motion.h1>
            {subtitle && <motion.p variants={fadeUp} className="mt-2 text-sm text-zinc-500">{subtitle}</motion.p>}
            <motion.div variants={fadeUp} className="mt-9">{children}</motion.div>
            {footer && <motion.div variants={fadeUp} className="mt-8">{footer}</motion.div>}
          </motion.div>
        </div>
      </div>
    </div>
  );
}
